module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_42.1ffb64c5.jpg";